"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var sortLinks = function sortLinks(categoryLinks) {
  return categoryLinks.map(function (category) {
    return {
      id: category.id,
      sort: category.sort,
      title: category.title,
      links: category.links.sort(function (linkA, linkB) {
        return linkA.sort - linkB.sort;
      })
    };
  }).sort(function (categoryA, categoryB) {
    return categoryA.sort - categoryB.sort;
  });
};

var _default = sortLinks;
exports["default"] = _default;